<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <path class="cls-2" d="m77.8,30.67v5.3H12.28v-5.3c0-2.52,2.06-4.59,4.59-4.59h56.34c2.52,0,4.59,2.07,4.59,4.59Z"/>
    <path class="cls-5" d="m79.28,37.45H10.79v-6.79c0-3.35,2.72-6.08,6.07-6.08h56.34c3.35,0,6.08,2.73,6.08,6.08v6.79Zm-65.52-2.98h62.54v-3.81c0-1.71-1.39-3.1-3.1-3.1H16.86c-1.71,0-3.1,1.39-3.1,3.1v3.81Z"/>
  </g>
  <path class="cls-5" d="m73.2,65.49H16.86c-3.35,0-6.07-2.72-6.07-6.07v-24.94h68.5v24.94c0,3.35-2.73,6.07-6.08,6.07ZM13.77,37.45v21.96c0,1.71,1.39,3.1,3.1,3.1h56.34c1.71,0,3.1-1.39,3.1-3.1v-21.96H13.77Z"/>
  <circle class="cls-1" cx="17.71" cy="31.02" r="1.91"/>
  <circle class="cls-1" cx="24.1" cy="31.02" r="1.91"/>
  <circle class="cls-1" cx="30.5" cy="31.02" r="1.91"/>
  <g>
    <g>
      <path class="cls-3" d="m38.44,50.79c0,4.94-4,8.94-8.94,8.94s-8.94-4-8.94-8.94,4-8.94,8.94-8.94v8.94l8.59-2.49c.23.79.35,1.63.35,2.49Z"/>
      <path class="cls-4" d="m39.26,46.68l-8.59,2.49v-8.94c4.07,0,7.5,2.72,8.59,6.45Z"/>
    </g>
    <g>
      <path class="cls-3" d="m69.51,44.73h-21.66c-.82,0-1.49-.67-1.49-1.49s.67-1.49,1.49-1.49h21.66c.82,0,1.49.67,1.49,1.49s-.67,1.49-1.49,1.49Z"/>
      <path class="cls-3" d="m69.51,51.47h-21.66c-.82,0-1.49-.67-1.49-1.49s.67-1.49,1.49-1.49h21.66c.82,0,1.49.67,1.49,1.49s-.67,1.49-1.49,1.49Z"/>
      <path class="cls-3" d="m69.51,58.21h-21.66c-.82,0-1.49-.67-1.49-1.49s.67-1.49,1.49-1.49h21.66c.82,0,1.49.67,1.49,1.49s-.67,1.49-1.49,1.49Z"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "KpiDashboardIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #66c8c9;
  }
  .cls-3 {
    fill: #187382;
  }
  .cls-4 {
    fill: #b6dfcf;
  }
  .cls-5 {
    fill: #65c8c9;
  }
</style>